<template>
    <widget-position-layout>
        <component
            :is="componentForGreeting"
            v-if="componentForGreeting"
        />
        <component
            :is="componentIcon"
            :class="componentClass"
            @click="onComponentClicked()"
        />
    </widget-position-layout>
</template>

<script setup lang="ts">
    import { computed, onMounted } from 'vue';
    import { Variant, VisitorInteractionType } from '@keyvue/one-api-client';
    import useAnimating from '@/composables/useAnimating';
    import useWidgetState, { State } from '@/composables/useWidgetState';
    import useConfiguration from '@/composables/useConfiguration';
    import useWidgetAppearance from '@/composables/useWidgetAppearance';
    import WidgetPositionLayout from '@/components/layout/WidgetPositionLayout.vue';
    import useVisitorData from '@/composables/useVisitorData';

    const { animating, startAnimating } = useAnimating();
    const { state } = useWidgetState();
    const { assistent } = useConfiguration();
    const { variantForIcon, componentIcon, componentForGreeting } = useWidgetAppearance();
    const { registerInteraction } = useVisitorData();

    const componentClass = computed(() => {
        return {
            'open-button': true,
            'open-button--animating': animating.value,

            // @todo: dit lijkt verkeerd om te staan, echter hebben we de styling ook verkeerd om staan
            // @todo: moet aangepast worden en goed doorgetest worden
            'open-button--square': !variantForIcon.value?.equals(Variant.SQUARE),
            'open-button--rectangle': variantForIcon.value?.equals(Variant.SQUARE),
        };
    });

    async function onComponentClicked() {
        state.value = State.Opened;
        await registerInteraction(VisitorInteractionType.WIDGET_CLICKED);
    }

    onMounted(() => {
        const widget = assistent.value?.widget;
        if (!widget || widget.hintAfterSeconds === 0) {
            return;
        }

        startAnimating(
            widget.hintAfterSeconds,
            widget.repeatAfterSeconds,
        );
    });
</script>

<style scoped lang="scss">
    .open-button {
        color: var(--color-balloon);
        filter: drop-shadow(4px 4px 6px rgba(0, 0, 0, 0.3));
        pointer-events: auto;
        transition: transform 200ms ease;
        transform-origin: center center;
        cursor: pointer;

        &--square {
            max-width: 80px;
        }

        &--rectangle {
            max-width: 3rem;
        }

        &--animating {
            animation: wiggle 1s ease-in-out;
        }

        &:hover, &:active {
            transform: scale(.95);
        }
    }

    @keyframes wiggle {
        0% { transform: rotate(0deg) translateX(0) scale(1); }
        15% { transform: rotate(3deg) translateX(0.3rem) scale(1.05); }
        30% { transform: rotate(-3deg) translateX(-0.3rem) scale(1.05); }
        45% { transform: rotate(2deg) translateX(0.2rem) scale(1.03); }
        60% { transform: rotate(-2deg) translateX(-0.2rem) scale(1.03); }
        75% { transform: rotate(1deg) translateX(0.1rem) scale(1.02); }
        100% { transform: rotate(0deg) translateX(0) scale(1); }
    }
</style>
